import UserService from '@/api/user-service';
import EntidadeService from '@/api/entidade-service';
import { FETCH_USER } from './actions.type';
import { SET_USER, LOADING, SET_ENTIDADE } from './mutations.type';

export default {
  [FETCH_USER](context) {
    context.commit(LOADING, true);
    return UserService.getUser()
      .then((response) => {
        context.commit(SET_USER, response.data);
        return EntidadeService.getEntidade()
          .then((entidadeResponse) => {
            context.commit(SET_ENTIDADE, entidadeResponse.data);
          });
      })
      .finally(() => {
        context.commit(LOADING, false);
      });
  },
};
